import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var PowerBI = props => /*#__PURE__*/_jsx("iframe", _extends({
  "data-chromatic": "ignore",
  className: "min-h-[400px] md:min-h-[600px] lg:min-h-[750px] xl:min-h-[900px]",
  width: "100%",
  frameBorder: 0,
  allowFullScreen: true
}, props));
//# sourceMappingURL=powerbi.js.map